var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.despacho.loading
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "container-despacho" }, [
          _c("div", [
            _vm.despacho.infos.includes("DOCUMENTOS") && _vm.despacho.documentos
              ? _c(
                  "div",
                  _vm._l(
                    _vm.despacho.documentos.filter(function(documento) {
                      return documento.tipo.codigo !== "ANEXO_ANALISE"
                    }),
                    function(documento) {
                      return _c(
                        "div",
                        { key: documento.id },
                        [
                          _vm.bytes
                            ? _c("AppModalVisualizaPdf", {
                                attrs: {
                                  titulo: documento.nome,
                                  arrayBuffer: _vm.bytes
                                },
                                on: {
                                  closeModal: function() {
                                    return (_vm.bytes = null)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              on: {
                                click: function($event) {
                                  return _vm.handleViewDocumento(documento)
                                }
                              }
                            },
                            [_vm._v(_vm._s(documento.tipo.descricao))]
                          )
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.despacho.infos.includes("DOCUMENTOS_ANEXOS") &&
            _vm.despacho.documentos
              ? _c("div", [
                  _c(
                    "div",
                    [
                      _vm.arrayBytes.length
                        ? _c("AppModalVisualizaPdf", {
                            attrs: {
                              titulo: "Documentos",
                              arrayBuffer: _vm.arrayBytes,
                              isMultiple: true
                            },
                            on: {
                              closeModal: function() {
                                return (_vm.arrayBytes = [])
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function($event) {
                              _vm.handleViewDocumentos(
                                _vm.despacho.documentos.filter(function(
                                  documento
                                ) {
                                  return (
                                    documento.tipo.codigo === "ANEXO_ANALISE"
                                  )
                                })
                              )
                            }
                          }
                        },
                        [_vm._v("Anexo(s) da análise")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.despacho.infos.includes("TEXTO")
            ? _c(
                "div",
                [
                  _c("app-display", {
                    attrs: {
                      label: "Despacho:",
                      content: _vm.despacho.texto,
                      isContentInNextLine: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.despacho.infos.includes("ANALISTA")
            ? _c(
                "div",
                [
                  _c("app-display", {
                    attrs: {
                      label: "Responsável:",
                      content: _vm.despacho.nomeAnalista,
                      isContentInNextLine: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.despacho.infos.includes("DATA")
            ? _c(
                "div",
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data:",
                      content: _vm.despacho.dataCadastro,
                      isContentInNextLine: true
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-despacho" }, [_vm._v("Dados")]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25582ceb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25582ceb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Processo/components/Despacho/Despacho.vue
// module id = null
// module chunks = 